<template>
    <div>

        <div class="app-tab-navigation">
            <div class="app-tab-navigation__breadcrumbs">
                <a class="app-tab-navigation__breadcrumb" :href="`/clients/${project.client.id}`">
                <svg class="element-icon--breadcrumb element-icon" width="1em" height="1em" title=""><use href="/img/icons.svg#icon-breadcrumb"></use></svg>
                {{ project.client.name }}
                </a>
                <svg class="element-icon--chevron-right element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-chevron-right"></use></svg>
                <a class="app-tab-navigation__breadcrumb" :href="`/projects/${project.id}/courses`">
                <svg class="element-icon--breadcrumb element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-breadcrumb"></use></svg>
                {{ project.name }}
                </a>
            </div>
            <h1 class="app-tab-navigation__title">Golden Source</h1>
            <ul class="app-tab-navigation__nav">
                <li class="is--active">
                    <a :href="`/project-sources/${projectSource.id}/review`">Repository</a>
                </li>
                <li>
                    <a :href="`/project-sources/${projectSource.id}/images`">Images</a>
                </li>
                <li>
                    <a :href="`/projects/${project.id}/sources/${projectSource?.id}`">Source Documents</a>
                </li>
            </ul>
        </div>
        <div class="app-project-sources-golden-source page-main">
            <div class="page-main__content grid">
                <ProjectSourcesNavBar
                    :project="project"
                    :topics="localTopics"
                    :projectSource="projectSource"
                    :topic="normalizedTopic"
                    :unsavedTopic="unsavedTopic"
                    @expand="updateExpanded($event)"
                    class="col-12 col-md-5 col-lg-4 col-xl-3">
                </ProjectSourcesNavBar>
                <ProjectSourcesContent
                    :currentTopic="normalizedTopic"
                    :sourceChunks=chunks
                    @topicUpdated="updateTopicsData($event)"
                    @topicChanged="changedTopic($event)"
                    class="col-12 col-md-7 col-lg-8 col-xl-9">
                </ProjectSourcesContent>
            </div>
        </div>
    </div>
</template>
<script>

import ProjectSourcesNavBar from './ProjectSourcesNavBar.vue';
import ProjectSourcesContent from './ProjectSourcesContent.vue';
import _ from 'lodash';
import api from '../api/ai'

export default {
    name: 'ProjectSources',
    components: {
        ProjectSourcesNavBar,
        ProjectSourcesContent
    },
    props: {
        project: {
            type: Object,
            required: true
        },
        topics: {
            type: Array
        },
        projectSource: {
            type: Object
        },
        chunks: {
            type: Array
        },
        topic: {
            type: [Object, String],
            default: null
        }
    },
    data() {
        return {
            currentExpanded: [],
            localTopics: this.topics,
            unsavedTopic: null
        }
    },
    computed: {
        normalizedTopic() {
            return this.topic === 'null' ? null : this.topic;
        }
    },
    beforeMount() {
        this.localTopics = this.topics
    },
    methods: {
        updateExpanded(topic) {
            const index = this.currentExpanded.indexOf(topic.uuid);
            if (index > -1) {
                this.currentExpanded.splice(index, 1);
            } else {
                this.currentExpanded.push(topic.uuid);
            }
        },
        async updateTopicsData(updatedTopic) {
            this.localTopics.forEach((topic, domainIndex) => {
                const topicIndex = topic.topics.findIndex(topic => topic.uuid === updatedTopic.uuid);
                if (topicIndex !== -1) {
                    this.localTopics[domainIndex].topics[topicIndex] = updatedTopic;
                }
            })
            this.unsavedTopic = null

            await this.refreshTopics()
        },
        async refreshTopics() {
            const result = await api.getTopics(this.projectSource.id)
            if (result.errors) {

            } else {
                this.localTopics = result.sourceTopics
            }
        },
        changedTopic: _.debounce(function(topic) {
            console.log('Changed topic:', topic);
            this.unsavedTopic = topic;
        }, 300)
    }
}
</script>